class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }
  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }
  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });
    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      {
        once: true,
      }
    );
    document.body.classList.add('overflow-hidden');
  }
  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }
  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');
    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }
    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });
    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }
  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });
    const parsedHTML = new DOMParser().parseFromString(parsedState.sections['cart-drawer'], 'text/html');

    const isEmpty = parsedHTML.querySelector('cart-drawer')?.classList.contains('is-empty');
    this.classList.toggle('is-empty', isEmpty);
    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }
  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }
  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }
  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }
  setActiveElement(element) {
    this.activeElement = element;
  }
}
customElements.define('cart-drawer', CartDrawer);
class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}
customElements.define('cart-drawer-items', CartDrawerItems);
/*
class DonationProducts extends HTMLElement {
  constructor() {
    super();
    this.state = {
      value: null,
      cartData: null,
      selectedDonation: null,
      isSubmitting: false,
    };
    this.selectOptions = [];
    this.donationVariants = {};
    this.boundCheckout = null;
    this.checkoutButton = null;
  }

  connectedCallback() {
    this.selectOptions = this.getSelectOptions();
    this.donationVariants = this.parseDonationVariants();
    this.init();
  }

  disconnectedCallback() {
    if (this.checkoutButton && this.boundCheckout) {
      this.checkoutButton.removeEventListener('click', this.boundCheckout);
      this.checkoutButton = null;
      this.boundCheckout = null;
    }
  }

  // ─── Parsing ──────────────────────────────────────────────────────────────

  getSelectOptions() {
    return [...this.querySelectorAll('input[name="donation-option"]')].map((input) => {
      const label = this.querySelector(`label[for="${input.id}"]`);
      const image = label?.querySelector('img');
      return { title: input.value, available: true, image: image ? image.src : null };
    });
  }

  parseDonationVariants() {
    const script = this.querySelector('.donation-variants');
    if (!script) return {};
    return JSON.parse(script.textContent);
  }

  getInputs() {
    return this.querySelectorAll('input[name="donation-option"]');
  }

  // ─── Cart ─────────────────────────────────────────────────────────────────

  async fetchCart() {
    return fetch('/cart.js').then((res) => res.json());
  }

  getCartItems() {
    return this.state.cartData?.items || [];
  }

  getSubscriptionItems() {
    return this.getCartItems().filter(
      (item) => item.selling_plan_allocation != null && item.handle !== window.cartStrings.donation_product
    );
  }

  getOneTimeItems() {
    return this.getCartItems().filter(
      (item) => item.selling_plan_allocation == null && item.handle !== window.cartStrings.donation_product
    );
  }

  hasNonDonationItems() {
    return this.getCartItems().some((item) => item.handle !== window.cartStrings.donation_product);
  }

  // ─── Selling plan helpers ─────────────────────────────────────────────────

  // Parses "df:4 MONTH;bf:4 MONTH;..." → intervalCount 4
  getIntervalCountFromSellingPlan(sellingPlan) {
    const val = sellingPlan?.options?.[0]?.value || '';
    const dfSegment = val.split(';').find((s) => s.startsWith('df:'));
    if (!dfSegment) return null;
    const intervalCount = Number(dfSegment.slice(3).split(' ')[0]);
    return isNaN(intervalCount) ? null : intervalCount;
  }

  // Reads #juo-donations-data and returns the selling plan ID
  // whose df: intervalCount matches the given number
  getDonationSellingPlanId(intervalCount) {
    try {
      const script = document.getElementById('juo-donations-data');
      if (!script) return null;
      const plans = JSON.parse(script.textContent);
      const match = plans.find((p) => this.getIntervalCountFromSellingPlan(p) === intervalCount);
      // console.log('[Donation] getDonationSellingPlanId: intervalCount=' + intervalCount + ' => planId:', match?.id ?? null);
      return match?.id ?? null;
    } catch (e) {
      // console.error('[Donation] getDonationSellingPlanId error:', e);
      return null;
    }
  }

  // ─── Variant selection ────────────────────────────────────────────────────

  // Extract number from variant title e.g. "Hundehütte / 4 Monate" → 4
  getMonthsFromTitle(title) {
    const match = (title || '').match(/(\d+)/);
    return match ? Number(match[1]) : null;
  }

  getSelectedDonation() {
    if (!this.state.value) return null;

    const variants = this.donationVariants[this.state.value.title];
    if (!variants?.length) return null;

    const subscriptionItems = this.getSubscriptionItems();

    // ── One-time: no subscription in cart → pick "Einmalig" variant ──
    if (!subscriptionItems.length) {
      return (
        variants.find((v) => /einmalig/i.test(v.title)) ||
        variants.find((v) => this.getMonthsFromTitle(v.title) === null) ||
        null
      );
    }

    // ── Subscription: match variant title number to cart intervalCount ──
    const cartIntervalCount = this.getIntervalCountFromSellingPlan(
      subscriptionItems[0].selling_plan_allocation.selling_plan
    );
    // console.log('[Donation] getSelectedDonation: cartIntervalCount:', cartIntervalCount);

    if (cartIntervalCount !== null) {
      // Exact match e.g. cart has 4 months → find "/ 4 Monate"
      const exact = variants.find((v) => this.getMonthsFromTitle(v.title) === cartIntervalCount);
      if (exact) {
        // console.log('[Donation] getSelectedDonation: exact match:', exact.title);
        return exact;
      }

      // Fallback: use highest available month ≤ cartIntervalCount
      const available = variants
        .map((v) => ({ v, n: this.getMonthsFromTitle(v.title) }))
        .filter(({ n }) => n !== null && n <= cartIntervalCount)
        .sort((a, b) => b.n - a.n);

      if (available.length) {
        // console.log('[Donation] getSelectedDonation: fallback to highest available:', available[0].v.title);
        return available[0].v;
      }

      // Last resort: first numbered variant
      const first = variants.find((v) => this.getMonthsFromTitle(v.title) !== null);
      // console.log('[Donation] getSelectedDonation: last resort:', first?.title);
      return first || null;
    }

    return null;
  }

  select(option) {
    this.state.value = option;
    this.state.selectedDonation = this.getSelectedDonation();
  }

  // ─── Cart mutations ───────────────────────────────────────────────────────

  async clearCartDonations() {
    const cart = await this.fetchCart();
    const donationItems = cart.items.filter((item) => item.handle === window.cartStrings.donation_product);
    if (!donationItems.length) return;

    const updates = {};
    donationItems.forEach((item) => {
      updates[item.key] = 0;
    });

    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates, sections: ['cart-drawer', 'cart-icon-bubble', 'donation-products'] }),
    }).then((res) => res.json());
  }

  async rerenderDrawer() {
    if (DonationProducts._rerendering) return;
    DonationProducts._rerendering = true;
    try {
      const sections = await fetch('/?sections=cart-drawer,cart-icon-bubble').then((r) => r.json());
      document.querySelector('cart-drawer')?.renderContents({ sections });
    } finally {
      setTimeout(() => {
        DonationProducts._rerendering = false;
      }, 0);
    }
  }

  async updateDonations() {
    this.state.cartData = await this.fetchCart();

    if (!this.hasNonDonationItems()) {
      await this.clearCartDonations();
      await this.rerenderDrawer();
      return;
    }

    await this.clearCartDonations();

    // Re-fetch after clear so cart state is fresh
    this.state.cartData = await this.fetchCart();

    const donation = this.getSelectedDonation();
    // console.log('[Donation] updateDonations: selected donation variant:', donation);

    if (!donation) {
      // console.warn('[Donation] no donation variant found, proceeding to checkout without donation');
      location.href = '/checkout';
      return;
    }

    const subscriptionItems = this.getSubscriptionItems();
    const cartSellingPlan = subscriptionItems[0]?.selling_plan_allocation?.selling_plan ?? null;
    const cartIntervalCount = this.getIntervalCountFromSellingPlan(cartSellingPlan);

    // Find the donation product's own selling plan ID for this frequency
    const donationSellingPlanId = cartIntervalCount !== null ? this.getDonationSellingPlanId(cartIntervalCount) : null;

    // console.log('[Donation] cartIntervalCount:', cartIntervalCount);
    // console.log('[Donation] donationSellingPlanId:', donationSellingPlanId);

    const payload = {
      items: [
        {
          id: donation.id,
          quantity: 1,
          ...(donationSellingPlanId && { selling_plan: donationSellingPlanId }),
          properties: {
            _selling_plan_id: cartSellingPlan ? String(cartSellingPlan.id) : '',
          },
        },
      ],
      sections: ['cart-drawer', 'cart-icon-bubble', 'donation-products'],
    };
    // console.log('[Donation] /cart/add.js payload:', payload);

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
    const parsedState = await response.json();
    // console.log('[Donation] /cart/add.js response:', parsedState);

    if (parsedState.status && parsedState.status >= 400) {
      // console.error('[Donation] add failed:', parsedState.description);
      // Still proceed to checkout even if donation add fails
      location.href = '/checkout';
      return;
    }

    document.querySelector('cart-drawer')?.renderContents(parsedState);
    location.href = '/checkout';
  }

  // ─── UI ───────────────────────────────────────────────────────────────────

  setCheckoutButtonLoadingState(value) {
    if (!this.checkoutButton) return;
    const spinner = this.checkoutButton.querySelector('.loading__spinner');
    if (value) {
      this.checkoutButton.classList.add('loading');
      this.checkoutButton.setAttribute('aria-disabled', true);
      this.checkoutButton.disabled = true;
      spinner?.classList.remove('hidden');
    } else {
      this.checkoutButton.classList.remove('loading');
      this.checkoutButton.setAttribute('aria-disabled', false);
      this.checkoutButton.disabled = false;
      spinner?.classList.add('hidden');
    }
  }

  async checkout(event) {
    event.preventDefault();
    if (this.state.isSubmitting) return;
    this.state.isSubmitting = true;
    this.setCheckoutButtonLoadingState(true);
    try {
      await this.updateDonations();
    } catch (error) {
      // console.error('[Donation] checkout error:', error);
      location.href = '/checkout';
    } finally {
      this.state.isSubmitting = false;
      this.setCheckoutButtonLoadingState(false);
    }
  }

  // ─── Init ─────────────────────────────────────────────────────────────────

  bindEvents() {
    this.getInputs().forEach((input) => {
      input.addEventListener('change', () => {
        const option = this.selectOptions.find((opt) => opt.title === input.value);
        if (option) this.select(option);
      });
    });

    this.checkoutButton = document.querySelector('#CartDrawer-Checkout');
    if (this.checkoutButton) {
      if (this.boundCheckout) this.checkoutButton.removeEventListener('click', this.boundCheckout);
      this.boundCheckout = this.checkout.bind(this);
      this.checkoutButton.addEventListener('click', this.boundCheckout);
    }
  }

  setDefaultSelection() {
    const first = this.selectOptions[0];
    if (first) this.select(first);
  }

  async init() {
    if (DonationProducts._rerendering) return;

    this.state.cartData = await this.fetchCart();

    const hasRealItems = this.state.cartData.items.some((item) => item.handle !== window.cartStrings.donation_product);

    if (!hasRealItems) {
      const hasDonations = this.state.cartData.items.some(
        (item) => item.handle === window.cartStrings.donation_product
      );
      if (hasDonations) {
        await this.clearCartDonations();
        await this.rerenderDrawer();
      }
      return;
    }

    this.bindEvents();
    this.setDefaultSelection();
  }
}

DonationProducts._rerendering = false;
if (!customElements.get('donation-products')) {
  customElements.define('donation-products', DonationProducts);
}
*/
if (!customElements.get('upsell-product-form')) {
  customElements.define(
    'upsell-product-form',
    class UpsellProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.submitButton = this.querySelector('[type="submit"]');
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.form?.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      async onSubmitHandler(event) {
        event.preventDefault();
        if (this.submitButton?.getAttribute('aria-disabled') === 'true') {
          return;
        }
        const spinner = this.querySelector('.loading__spinner');
        const upsellCartBtn = this.querySelector('.upsell-cart-btn');
        try {
          spinner?.classList.remove('hidden');
          upsellCartBtn?.style.setProperty('opacity', '0');
          const formData = new FormData(this.form);
          if (this.cart) {
            formData.append(
              'sections',
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }
          const response = await fetch(`${routes.cart_add_url}.js`, {
            method: 'POST',
            headers: {
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: formData,
          });
          const parsedState = await response.json();
          const drawer = document.querySelector('cart-drawer');
          if (drawer) {
            drawer.renderContents(parsedState);
          }
        } catch (error) {
          // console.error('[UpsellProductForm]', error);
        } finally {
          spinner?.classList.add('hidden');
          upsellCartBtn?.style.setProperty('opacity', '1');
        }
      }
    }
  );
}
